
export enum API_STATES {
    Initial = "Initial",
    Loading = "InProgress",
    Success = "Success",
    Failed = "Failed",
  }